import React, { Component } from 'react';
import PropTypes from 'prop-types';
import build from '../../version';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <div style={{ display: 'flex', flexDirection: 'column'}}>
        <span className="ml-auto">Onecore Sales System by <a href="https://www.gustavodelgado.cc/">Gustavo Delgado</a></span>
        <div className="oss-build">
            Build v{build.version}{build.hash ? ' · ' + build.hash : ''}{build.date ? ' · ' + build.date : ''}
        </div>
      </div>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;



// WEBPACK FOOTER //
// ./src/Containers/DefaultLayout/DefaultFooter.js